<template>
  <router-view :key="key"/>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  computed: {
    key() {
      return this.$store.state.key
    }
  },
  created() {

  },
  mounted() {
    (function (d, w, s) {
      var widgetHash = '8kde3q8wuh74g0jub7s7', gcw = d.createElement(s);
      gcw.type = 'text/javascript';
      gcw.async = true;
      gcw.src = '//widgets.binotel.com/getcall/widgets/' + widgetHash + '.js';
      var sn = d.getElementsByTagName(s)[0];
      sn.parentNode.insertBefore(gcw, sn);
    })(document, window, 'script');
  }
}
</script>

<style lang="less">

</style>
